export const seasonalPerks = [
  {
    label: 'Early access to members only sales',
    check: false,
    boldText: '',
    additionalLabel: '',
  },
  {
    label: 'More box customization offers',
    check: false,
    boldText: '',
    additionalLabel: '',
  },
  {
    label: 'Earlier shipping',
    check: false,
    boldText: '',
    additionalLabel: '',
  },
  {
    label: 'The Seasonal Box:',
    check: true,
    boldText: 'a $200+ value',
    additionalLabel: '',
  },
  {
    label: 'Customize your box',
    check: true,
    boldText: '',
    additionalLabel: 'Customize some of your box',
  },
  {
    label: 'Members Only Sales',
    check: true,
    boldText: '',
    additionalLabel: '',
  },
];

export const annualPerks = [
  {
    label: 'Early access to members only sales',
    check: true,
    boldText: '',
    additionalLabel: '',
  },
  {
    label: 'More box customization offers',
    check: true,
    boldText: '',
    additionalLabel: '',
  },
  {
    label: 'Earlier shipping',
    check: true,
    boldText: '',
    additionalLabel: '',
  },
  {
    label: '4 Seasonal Boxes:',
    check: true,
    boldText: 'an $800+ value',
    additionalLabel: '',
  },
  {
    label: 'Customize your box',
    check: true,
    boldText: '',
    additionalLabel: 'Customize some of your box',
  },
  {
    label: 'Members Only Sales',
    check: true,
    boldText: '',
    additionalLabel: '',
  },
];

export const mobileTablePerks = [
  { label: 'Early access to sales', seasonalIncluded: false, additionalLabel: '' },
  {
    label: 'More box customization',
    seasonalIncluded: false,
    additionalLabel: 'Customize some of your box',
  },
  { label: 'Earlier shipping', seasonalIncluded: false, additionalLabel: '' },
  { label: '$200+ value per box', seasonalIncluded: true, additionalLabel: '' },
  { label: 'Customize Your Box', seasonalIncluded: true, additionalLabel: '' },
  { label: 'Members Only Sales', seasonalIncluded: true, additionalLabel: '' },
];

export const additionalPerks = [
  { label: 'Unlimited Swap for Credit', check: true, seasonalIncluded: true },
];

export const UPGRADE_TRACK_NAME = 'Upgrade Completed';
export const UPGRADE_CTA_NAME = 'Yes, Upgrade Me!';
